var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnKakao18 = function SvgLightIcnKakao18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "light_icn_kakao_18_svg__a",
    width: 12,
    height: 12,
    x: 3,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3 3.5h12v11H3z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#light_icn_kakao_18_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191600",
    fillRule: "evenodd",
    d: "M9 3.5c-3.314 0-6 2.104-6 4.7 0 1.678 1.123 3.152 2.813 3.981-.092.315-.591 2.026-.61 2.16 0 0-.013.101.053.14a.18.18 0 0 0 .143.008c.19-.026 2.192-1.422 2.538-1.662q.53.073 1.063.072c3.314 0 6-2.104 6-4.7S12.314 3.5 9 3.5",
    clipRule: "evenodd"
  }))));
};
export default SvgLightIcnKakao18;